<template>
  <div class="data-sub">
    <div class="data-sub-body">
      <div style="padding-bottom: 5px">
        <span>请选择年度：</span>
        <el-date-picker
          :clearable="false"
          size="small"
          v-model="searchParams.year"
          value-format="yyyy"
          type="year"
          :picker-options="pickerOptions"
          @change="getList()"
          placeholder="选择年"
        >
        </el-date-picker>
      </div>
      <el-table
        size="small"
        height="400px"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="name"
        border
      >
        <el-table-column align="center" label="序号" width="80">
          <template scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="危废名称">
        </el-table-column>
        <el-table-column align="center" prop="type" label="危险废物类别">
        </el-table-column>
        <el-table-column align="center" prop="code" label="危险废物代码">
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="handleCompanyName"
          label="处置单位"
        >
        </el-table-column> -->
        <el-table-column align="center" prop="yearOutPut" label="产生量（吨）">
        </el-table-column>
      </el-table>
      <div class="tb-body">
        <div class="tb-search">
          <div class="tb-search-item">
            <span>请选择基准年：</span>
            <el-date-picker
              :clearable="false"
              size="small"
              v-model="searchParams2.basicYear"
              value-format="yyyy"
              type="year"
              :picker-options="basicYearOptions"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div class="tb-search-item">
            <span>请选择比较年：</span>
            <el-date-picker
              :clearable="false"
              size="small"
              v-model="searchParams2.compareYears"
              value-format="yyyy"
              type="years"
              :picker-options="compareYearsOptions"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div class="tb-search-item">
            <el-button size="small" type="primary" @click="getYeartoYearData()"
              >查询</el-button
            >
          </div>
        </div>
        <div class="tb-chart">
          <div id="charts-tb" style="width: 100%; height: 100%"></div>
          <!-- <v-chart :option="option_column" style="width: 100%; height: 400px"></v-chart> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  components: {},
  props: {
    companyId: {
      default: 0,
    },
  },
  data() {
    const searchParams = {
      year: `${new Date().getFullYear()}`,
    };
    const searchParams2 = {
      basicYear: `${new Date().getFullYear()}`,
      compareYears: [`${new Date().getFullYear() - 1}`],
    };
    return {
      dataSource: [],
      searchParams,
      searchParams2,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      basicYearOptions: {
        disabledDate(time) {
          const year = `${time.getFullYear()}`;
          return (
            time.getTime() > Date.now() ||
            searchParams2.compareYears?.includes(year)
          );
        },
      },
      compareYearsOptions: {
        disabledDate(time) {
          const year = `${time.getFullYear()}`;
          return time.getTime() > Date.now() || year == searchParams2.basicYear;
        },
      },
    };
  },
  watch: {
    companyId(val) {
      this.getList();
      this.getYeartoYearData();
      this.drawChart();
    },
  },
  computed: {},
  methods: {
    getList() {
      const params = this.searchParams;
      if (this.companyId) params.companyId = this.companyId;
      let url = this.$api.dangerWasterDatas.getCompanyYearDangerData;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { data } = res.data.data;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 4) {
          const values = data.map((item) => Number(item['"yearOutPut"']));

          var sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = sum + " 吨";
        } else {
          sums[index] = "";
          return;
        }
      });

      return sums;
    },
    //获取同比数据
    getYeartoYearData() {
      const { basicYear, compareYears } = this.searchParams2;
      const params = {
        basicYear,
        compareYears: compareYears.join("、"),
      };
      if (this.companyId) params.companyId = this.companyId;
      let url = this.$api.dangerWasterDatas.getYearOnYearDangerData;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { data } = res.data.data;

          this.drawChart(data);
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    drawChart(data = []) {
      const xData = data.map((d) => d.Key);
      const seriesData = data.map((d) => d.Value);
      const tbCharts = echarts.init(document.getElementById("charts-tb"));
      let options = {
        title: {
          text: "数据同比", //图表顶部的标题
        },
        xAxis: {
          type: "category",
          data: xData,
        },
        yAxis: {
          name: "单位:吨",
          nameTextStyle: {},
          type: "value",
        },
        series: [
          {
            data: seriesData,
            type: "bar",
            barWidth: 20,
            label: {
              //柱体上显示数值
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#666",
              },
              formatter: "{c}吨",
            },
          },
        ],
      };

      tbCharts.setOption(options);
    },
  },

  mounted() {
    // this.companyId = this.$route.params.companyId
    this.getList();
    this.getYeartoYearData();

    this.drawChart();
  },
};
</script>

<style lang="scss" scoped>
.data-sub {
  height: 100%;

  .data-sub-body {
    height: 100%;
  }

  .tb-body {
    display: flex;
    height: calc(45% - 40px);

    .tb-search {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .tb-search-item {
        padding: 10px;
      }
    }

    .tb-chart {
      flex: 1;
    }
  }
}
</style> 